import RegFormsLinksContainer from './RegFormsLinksContainer';

export default RegFormsLinksContainer;
